Customer.Tabs ||= {}

class Customer.Tabs.SmartContainerView extends Backbone.View # implements ContainerView

  # This implementation detaches the inactive views' elements from the DOM.

  initialize: (@options = {}) ->
    @activeView = @options.activeView || throw new Error('Cannot instantiate a ContainerView without an activeView')
    @detachedElementsById = {}
    @viewIdsToDiscard = {}
    @viewsScrollPosition = {}

  render: ->
    @$el.html(@_activeViewEl())
    @

  setActiveView: (view, refresh) ->
    @viewsScrollPosition[@activeView.uniqueId()] = @activeView.currentScrollPosition()

    unless refresh
      return if view.uniqueId() == @activeView.uniqueId()
      if @viewIdsToDiscard[@activeView.uniqueId()]
        @viewIdsToDiscard[@activeView.uniqueId()] = false
        @$el.children().first().remove()
      else
        @activeView.onDetach() if @activeView.onDetach?
        @detachedElementsById[@activeView.uniqueId()] = @$el.children().first().detach()
    @activeView = view
    detachedElementToRestore = @detachedElementsById[view.uniqueId()]
    if detachedElementToRestore
      @$el.append(detachedElementToRestore)
      @activeView.onAttach() if @activeView.onAttach?
    else
      @render()
    @restoreScrollPosition(tries: 50)

  restoreScrollPosition: ({tries}) =>
    expectedScrollPosition = @viewsScrollPosition[@activeView.uniqueId()]
    @activeView.scrollTo(expectedScrollPosition)
    if tries > 0 && @activeView.currentScrollPosition() != expectedScrollPosition
      setTimeout(( => @restoreScrollPosition(tries: tries - 1)), 3)

  discardView: (view) ->
    @detachedElementsById[view.uniqueId()] = undefined
    @viewIdsToDiscard[view.uniqueId()] = true
    delete @viewsScrollPosition[view.uniqueId()]

  _activeViewEl: ->
    detachedElement = @detachedElementsById[@activeView.uniqueId()]
    if detachedElement
      detachedElement
    else
      @activeView.render().el
